var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bank-account-form',{attrs:{"listOfAssetsId":_vm.listOfAssetsId,"type":_vm.type},on:{"cancel":function($event){return _vm.$emit('cancel')},"back":function($event){return _vm.$emit('back')}}})}
var staticRenderFns = []

export { render, staticRenderFns }